import { useContext } from 'react';
import HostQualityContext from './HostQualityContext';

export const useHostQualityContext = () => {
  const context = useContext(HostQualityContext);
  if (!context) {
    throw new Error(
      'useHostQualityContext must be used within a HostQualityContextProvider',
    );
  }
  return context;
};
